// Filters, Фильтры с выпадающим списком на главной
import { Col, Row, Divider } from 'antd';
import { useSearchFilters } from 'hooks';
import SelectManager from '../selectManager';
import SelectCompanyType from '../selectCompanyType';
import { SecondaryBtn, DangerBtn } from 'components';
import SwitchPatentExpires from '../switchPatentExpires';
import SelectCompanyFilters from './selectCompanyFilters';
import SelectTemplateSetFilters from './selectTemplateSetFilters';

// Zustand store
import { useShallow } from 'zustand/react/shallow';
import { useContractsStore } from 'storeZustand';

const ContractsFilters = ({ selectedCity }) => {
	const { applyFilters } = useSearchFilters();

	// Договоры клиента
	const [
		resetFilters
	] = useContractsStore(useShallow((state) => [
		state.resetFilters
	]));

	return (
		<Row gutter={6} className='mb-2 justify-content-between'>
			<Col span={20}>
				<Row gutter={6} className='d-flex align-items-center'>
					<Col span={3}>
						{/* Выбор менеджера */}
						<SelectManager />
					</Col>
					<Divider type="vertical" />
					<Col span={3}>
						{/* Выбор типа компании */}
						<SelectCompanyType />
					</Col>
					<Divider type="vertical" />
					<Col span={3}>
						{/* Выбор названия шаблонов */}
						<SelectTemplateSetFilters />
					</Col>
					<Divider type="vertical" />
					<Col span={5}>
						{/* Выбор компании */}
						<SelectCompanyFilters />
					</Col>
					<Divider type="vertical" />
					<Col span={6}>
						{/* Истекает патент */}
						<SwitchPatentExpires selectedCity={selectedCity} />
					</Col>
					<Divider type="vertical" />
				</Row>
			</Col>
			<Col span={4} className='d-flex justify-content-between'>
				{/* Кнопки применить и сбросить фильтры */}
				<SecondaryBtn onClick={applyFilters}>Применить</SecondaryBtn>
				<DangerBtn onClick={resetFilters}>Сбросить</DangerBtn>
			</Col>
		</Row>
	)
}

export default ContractsFilters;